import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useHistory, useParams } from "react-router-dom";
import { usePermissionGuardRedirect } from "../../hooks/usePermissionGuard";
import { GetAssemblyResourceDetailCancelToken, GetDetailOfAssembliesCancelToken, GetLinkedCoursesCancelToken, GetListOfAssignedResourcesCancelToken, GetListOfAvailableResourcesCancelToken } from "../../services/CourseService";
import { GlobalIconNames } from "../../utils/GlobalIconNames";
import Header from "../common/Header";
import SideBar from "../common/SideBar";
import { TrimText } from "../common/TrimText";
import Assemblies from "./ContentAssembliesBlock/Assemblies";
import AssembliesDetails from "./ContentAssembliesBlock/AssembliesDetails";
import AssignedResource from "./ContentAssembliesBlock/AssembliesDetailsBlocks/AssignedResource";
import Swal from "sweetalert2";
import LinkedCourse from "./ContentAssembliesBlock/AssembliesDetailsBlocks/LinkedCourse";
import AuditTrail from "./ContentAssembliesBlock/AuditTrail";
import ResourcePool from "./ContentAssembliesBlock/ResourcePool";
import ResourcePoolDetails from "./ContentAssembliesBlock/ResourcePoolDetails";
import LinkedAssemblies from "./ContentAssembliesBlock/ResourcePoolDetailsBlocks/LinkedAssemblies";
import ListOfResources from "./ContentAssembliesBlock/ResourcePoolDetailsBlocks/ListOfResources";
import SubCategoryDetails from "./ContentAssembliesBlock/SubCategoryDetails";

const ContentAssemblies = () => {

  const { id, tab, type, subType } = useParams();
  const history = useHistory();
  const [headingName, setHeadingname] = useState();
  const [showTabs, setShowTabs] = useState(true);
  const [assignedData, setAssignedData] = useState();
  const [availableData, setAvailableData] = useState();
  const [linkedCourseData, setLinkedCourseData] = useState();
  const [isLoading2, setIsLoading2] = useState(true);
  const [isLoading3, setIsLoading3] = useState(true);
  const [filterData, setFilterData] = useState({status : [], intake : [], learning : []})
  const [fetchTable, setFetchTable] = useState(false)
  const [data, setData] = useState();
  const [triggerUpdate, setTriggerUpdate] = useState(Date.now());
  

  usePermissionGuardRedirect(['caview']);

  useEffect(() => {
    const dropdownSource = axios.CancelToken.source();
    const assemblyResourceDetail = axios.CancelToken.source();
    
    const fetchData = async () => {
      try {
        const res = await GetDetailOfAssembliesCancelToken(id, dropdownSource.token);
        if (res?.data?.assemblies_detail) {
          setData(res.data.assemblies_detail);
        }
        setHeadingname(res?.data?.assemblies_detail?.name)

        if (!res?.data?.assemblies_detail) {
          Swal.fire({
            icon: "Info",
            title: "Info",
            text: "No record found with this id",
          });
          history.push("/courses/content/assemblies/table");
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    };

    const fetchResourceDetail = async () => {
      try {
        const res = await GetAssemblyResourceDetailCancelToken({ item_id: id }, assemblyResourceDetail.token);
        setHeadingname(res?.data?.resouce_detail?.item_name);
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    };

    if (tab !== "assemblies" && id) {
      fetchResourceDetail();
    } else if (id) {
      fetchData();
    }

    if ((tab === "assemblies" && (type === "add" || type === "duplicate")) || (tab === "resource-pool" && (type === "add" || type === "open" || type === "create" || type === "duplicate"))) {
      setShowTabs(false);
    } else {
      setShowTabs(true);
    }

    return () => {
      dropdownSource.cancel('Component unmounted');
      assemblyResourceDetail.cancel('Component unmounted');
    };
  }, [tab, type, triggerUpdate, id])

  useEffect(() => {
    const availableResource = axios.CancelToken.source();
    const assignedResource = axios.CancelToken.source();
    const linkedCourseSource = axios.CancelToken.source();
  
    const fetchAvailableResources = async () => {
      try {
        const res = await GetListOfAvailableResourcesCancelToken({ assembly_id: id }, availableResource.token);
          if(res.status == 200){
            setAvailableData(res?.data?.avl_assemblies_list);
          }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    };

    const fetchAssignedResources = async () => {
      try {
        const res = await GetListOfAssignedResourcesCancelToken({ assembly_id: id }, assignedResource.token);
          if(res.status == 200){
            setAssignedData(res?.data?.assigned_assemblies_list);
            setIsLoading2(false)
          }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setIsLoading2(false)
        }
      }
    };

    const fetchLinkedCourses = async () => {
      try {
        const res = await GetLinkedCoursesCancelToken({ assembly_id: +id ,dynamicFilter: "true" }, linkedCourseSource.token);
          if(res.status == 200){
            setLinkedCourseData(res?.data?.linked_course_list);
            setFilterData({...res.data, status : res.data.aessmbliyStatusFiltere, learning : res.data.intakeTypeFilter, intake : res.data.yearsAndIntaksFilter})
            setIsLoading3(false);
          }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setIsLoading3(false);
        }
      }
    };
    if(id){  
      if (tab == "assemblies" && type === "linkedCourses") {
        fetchAvailableResources();
        fetchAssignedResources();
        fetchLinkedCourses();
      }
    } 
    return () => {
      availableResource.cancel('Component unmounted');
      assignedResource.cancel('Component unmounted');
      linkedCourseSource.cancel('Component unmounted');
    };
  }, [tab, type, headingName, fetchTable]);


  function setTabHeading() {
    let fName;
    let sName;

    // Conditions to set heading's first name accordingly
    if (tab == "assemblies" && type == "table") {
      fName = "Content ";
    } if (tab == "assemblies" && type == "add") {
      fName = "Add ";
    } else if (tab == "assemblies" && type !== "table") {
      fName = "Content Assembly : ";
    } else if (tab == "resource-pool" && (type == "table" || type == "create")) {
      fName = "Resource ";
    } else if (tab == "resource-pool" && type == "add") {
      fName = "Add ";
    } else if (tab == "resource-pool" && type !== "table") {
      fName = "Resource: ";
    } else {
      fName = "Content ";
    }

    // Conditions to set heading's second name accordingly
    if (tab == "resource-pool" && (type == "table" || type == "create")) {
      sName = "Pool";
    } else if (tab == "resource-pool" && type == "add") {
      sName = "Resource Pool";
    } else if (tab == "assemblies" && (type == "table" || type == "create")) {
      sName = "Assemblies";
    } else if (tab == "assemblies" && type == "add") {
      sName = "Assembly";
    } else if (tab == "resource-pool" && type !== "table") {
      sName = headingName;
    } else if (tab == "resource-pool" && type == "open" && !subType) {
      sName = headingName;
    } else if (tab == "assemblies" && type !== "table") {
      sName = headingName;
    } else {
      sName = "Assemblies";
    }

    return { fName, sName }; 
  }

  const { fName, sName } = setTabHeading();

  function assessmentRoutes() {
    if (tab == "assemblies" && type == "table") return `/courses/content/assemblies/table` ;
    if (tab !== "assemblies") {
      return `/courses/content/assemblies/table`;
    } else {
      return "/courses/content/assemblies/edit/" + id;
    }
  }

  function auditTrailRoutes() {
    if (type === "table") {
      return "/courses/content/audit-trail/table";
    } else {
      return `/courses/content/${tab}/edit/${id}/audit-trail`;
    }
  }

  function checkTabs() {
    if (type === "table") return;
    if (tab === "assemblies") {
      return innerTabsAssemblies();
    } else if (tab === "resource-pool") {
      return innerTabsResourcePool();
    }
  }

  function innerTabsAssemblies() {
    return (
      <>
        <li className="nav-item">
          <Link className={`nav-link ${tab == "assemblies" && type === "assignedResources" ? "active" : ""}`} to={`/courses/content/assemblies/assignedResources/${id}`}>
            <i className="fal fa-tasks"></i>Resources
          </Link>
        </li>
        <li className="nav-item">
          <Link className={`nav-link ${tab == "assemblies" && type === "linkedCourses" ? "active" : ""}`} to={`/courses/content/assemblies/linkedCourses/${id}`}>
            <i className="fal fa-link"></i>Linked Courses
          </Link>
        </li>
      </>
    )
  }

  function innerTabsResourcePool() {
    return (
      <>
        <li className="nav-item">
          <Link className={`nav-link ${tab === "resource-pool" && type === "listOfResources" ? "active" : ""}`} to={`/courses/content/resource-pool/listOfResources/${id}`}>
            <i className="fal fa-list"></i>List Of Resources
          </Link>
        </li>
        <li className="nav-item">
          <Link className={`nav-link ${tab === "resource-pool" && type === "linkedAssemblies" ? "active" : ""}`} to={`/courses/content/resource-pool/linkedAssemblies/${id}`}>
            <i className="fal fa-link"></i>Linked Assemblies
          </Link>
        </li>
      </>
    )
  }

  function tabSectionAssemblies() {
    return (<>
      {tab === "assemblies" && type === "linkedCourses" && <>
        <LinkedCourse data={linkedCourseData} setFetchTable={setFetchTable} fetchTable={fetchTable} isLoading3={isLoading3} filterData={filterData}/>
      </>}

      {tab === "assemblies" && type === "assignedResources" && <>
        <div className="card card-profile-info-card">
          <div className="">

            <div className="card-body-inr card-body-info">
              <div className="ass-bel-stuff">

                <AssignedResource data={assignedData} setFetchTable={setFetchTable} fetchTable={fetchTable} isLoading2={isLoading2} isLoading3={isLoading3} availableResData={availableData} />
              </div>
            </div>
          </div>
        </div>
      </>}
    </>
    )
  }

  function tabSectionResourcePool() {
    return (
      <div className="card card-profile-info-card">
        <div className="">

          <div className="card-body-inr card-body-info">
            <div className="ass-bel-stuff">
              {tab === "resource-pool" && type === "listOfResources" && <>
                <div className="card-header">List of Resources</div>
                <ListOfResources />
              </>}

              {tab === "resource-pool" && type === "linkedAssemblies" && <>
                <div className="card-header">Linked Assemblies</div>
                <LinkedAssemblies />
              </>}

            </div>
          </div>
        </div>
      </div>)
  }

  return (
    <>
      <Header />
      <div className="content-wrapper d-flex flex-wrap">
        <SideBar />
        <div className="sidebar-right">
          <div className="sub-menu-content-block">
            <div className="sub-menu-right-block">
              <div className="wrap-box-right">
                <div className="my-tickets-heading-blk flex-direction mb-2">
                  <div className="d-flex align-items-center ">
                    <div className="name-w-head d-flex align-items-center ">
                      <h4 className="text-left-align landing-heading heading_color_dynamic">
                        {fName}
                        <span title={sName ? sName : ""}>
                          {sName ? TrimText(sName, 25) : ""}
                        </span>
                      </h4>
                    </div>
                    <div className="text-md-right action2-blk">
                      <div className="ticket-view-btn d-flex align-items-center">
                        <div className="add-new-ticket-bx">
                          <button type="button" onClick={() => { history.go(-1) }} title="Back" className="btn btn-white-bordered">
                          {GlobalIconNames("leftarrow")}Back
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tabs-wrap">
                  <ul className={"nav nav-pills mb-4 " + (showTabs ? "" : "d-none")} id="tabs" role="tablist">
                    {(tab == "resource-pool" && type == "table") || tab == "assemblies" || tab == "audit-trail" ?
                      <li className="nav-item">
                        <Link className={`nav-link ${tab === "assemblies" && (type === "table" || type === "edit") && subType !== "audit-trail" ? "active" : ""}`} to={assessmentRoutes()}>
                          {((tab=="assemblies" || tab === "audit-trail")&& type === "table") ? <><i className="fal fa-info-circle"></i>Content Assembly</> : GlobalIconNames("details").html }
                        </Link>
                      </li> : null}
                    {tab === "assemblies" && type !== "table" ? checkTabs() : null}
                    {tab === "resource-pool" && type !== "table" ? checkTabs() : null}
                    <li className="nav-item" >
                      <Link className={`nav-link ${(tab === "audit-trail" || subType === "audit-trail") ? "active" : ""}`} to={auditTrailRoutes()}>
                      {GlobalIconNames("auditTrail").html}
                      </Link>
                    </li>
                  </ul>

                  <div className="tab-content" id="pills-tabContent">
                    <div className={"tab-pane fade active show"} id="pills-tab11" role="tabpanel" aria-labelledby="pills-tab1">
                      {tab == "assemblies" && type == "table" ? <Assemblies /> : ""}
                      {tab == "assemblies" && type == "edit" && !subType ? <AssembliesDetails data={data} setTriggerUpdate={setTriggerUpdate} /> : ""}
                      {tab == "assemblies" && type == "add" ? <AssembliesDetails /> : ""}
                      {tab == "assemblies" && type == "duplicate" ? <AssembliesDetails data={data} setTriggerUpdate={setTriggerUpdate} /> : ""}
                      {tab == "assemblies" && ["linkedCourses", "assignedResources"].includes(type) ? tabSectionAssemblies() : ""}
                    </div>
                    <div className="tab-pane fade active show" id="pills-tab22" role="tabpanel" aria-labelledby="pills-tab2">
                      {tab == "resource-pool" && type == "table" && !subType && <ResourcePool />}
                      {tab == "resource-pool" && type == "edit" && !subType && <ResourcePoolDetails setHeadingname={setHeadingname} />}
                      {tab == "resource-pool" && type == "add" && !subType && <ResourcePoolDetails setHeadingname={setHeadingname} />}
                      {tab == "resource-pool" && type == "open" && !subType && <ResourcePoolDetails setHeadingname={setHeadingname} />}
                      {tab == "resource-pool" && type == "duplicate" && !subType && <ResourcePoolDetails setHeadingname={setHeadingname} />}
                      {tab == "resource-pool" && type !== "add" && subType == "add" && <SubCategoryDetails />}
                      {tab == "resource-pool" && type !== "add" && subType == "add" && <SubCategoryDetails />}
                      {tab == "resource-pool" && type !== "add" && subType == "open" && <SubCategoryDetails />}
                      {tab == "resource-pool" && type !== "add" && subType == "duplicate" && <SubCategoryDetails />}
                      {tab == "resource-pool" && ["listOfResources", "linkedAssemblies"].includes(type) ? tabSectionResourcePool() : ""}

                    </div>
                    <div className="tab-pane fade active show" id="pills-tab33" role="tabpanel" aria-labelledby="pills-tab3">
                      {(tab == "audit-trail" || ((tab === "resource-pool" || tab === "assemblies") && subType === "audit-trail")) && <AuditTrail />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContentAssemblies;
